module.exports = __webpack_public_path__ + "img/xy_login.b0669a08.svg";